import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGI: CultureInfo = {
  name: 'en-GI',
  displayName: 'English (Gibraltar)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GI',
  parent: CultureInfoEn
};
